<template>
    <div class="literature">
        <router-view class="router" :keyword="searchKeyword"></router-view>
        <div class="btn-menu" @click="showBackButton = !showBackButton">
            <a-icon type="menu-unfold" v-if="showBackButton"/>
            <a-icon type="menu-fold" v-if="!showBackButton"/>
        </div>
        <div :class="{'menus': true, 'show': !showBackButton}">
            <div class="search-box">
                <input type="text" v-model="keyword" class="keyword" placeholder="請輸入搜索關鍵字" @keyup="onKeyUp">
                <button @click="doSearch"><a-icon type="search" class="icon"/>搜索</button>
            </div>
            <div class="tops">
                <div class="top-head">
                    <a-radio-group v-model="mode" :style="{ marginBottom: '8px' }" @change="onChange">
                        <a-radio-button value="1">
                            最新學術及文化
                        </a-radio-button>
                        <a-radio-button value="2">
                            瀏覽最多
                        </a-radio-button>
                    </a-radio-group>
                </div>
                <ul class="top-datas">
                    <li class="top-datas-item" v-for="(data, index) in dataList" :key="index" @click="showBackButton =true"><router-link :to="`/LiteratureDetail/${data.articleid}`" v-text="data.title"></router-link></li>
                </ul>
                <loading v-if="loading" />
            </div>
        </div>
    </div>
</template>

<script>
import Loading from '../../components/Loading'
export default {
    components: {
        Loading,
    },
    data(){
        return {
            mode: '1',
            title: '',
            keyword: '',
            searchKeyword: '',
            detail: null,
            loading: false,
            pageNo: 1,
            pageSize: 20,
            total: 0,
            visible: false,
            dataList: [],
            showBackButton: true,
        }
    },
    mounted: function(){
        this.keyword = this.$route.query.keyword || ''
        this.onRefresh()
    },
    methods: {
        onKeyUp: function(e) {
            if(e.key === 'Enter') {
                this.doSearch()
            }
        },
        doSearch: function(){
            this.showBackButton = true
            var keyword = this.keyword.trim()
            var params = keyword ? `?keyword=${keyword}` : ''
            var path = `/LiteratureList${params}`
            if(location.href.endsWith(path)) {
                this.searchKeyword = null
                setTimeout(() => {
                    this.searchKeyword = keyword
                }, 10)
            } else {
                this.$router.push(`/LiteratureList${params}`)
            }
        },
        onChange: function() {
            this.onRefresh()
        },
        onRefresh: function(){
            this.loading = true
            this.dataList = []
            if(this.mode==1) {
                this.$store.dispatch('getNewArticleList', { 'associationid': 4 })
                .then((rs)=>{
                    this.loading = false
                    this.dataList = rs.list || []
                })
                .catch((error)=>{
                    this.$message.warning(error || '操作失敗，請重試')
                })
            } else {
                this.$store.dispatch('getHotArticleList', { 'associationid': 4 })
                .then((rs)=>{
                    this.loading = false
                    this.dataList = rs.list || []
                })
                .catch((error)=>{
                    this.$message.warning(error || '操作失敗，請重試')
                })
            }
        }
    },
    watch: {
        '$route.query.keyword': function(keyword) {
            this.keyword = keyword || ''
        },
    }
}
</script>

<style scoped>
    .ant-radio-group {
        margin-bottom: 0px !important;
    }

    .literature {
        width: 1000px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        position: relative;
    }

    .literature > .btn-menu {
        position: fixed;
        left: 11px;
        top: 89px;
        width: 40px;
        height: 40px;
        border: 1px solid #e8e8e8;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 2px 2px 5px #eee, -2px -2px 5px #eee;
        display: none;
        align-items: center;
        justify-content: center;

    }

    .literature > .btn-menu:active {
        opacity: 0.7;
    }

    .literature > .router {
        flex: 1;
        margin-right: 20px;
    }

    .literature > .menus {
        width: 292px;
        display: flex;
        flex-direction: column;
    }

    .literature > .menus > .search-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
        position: relative;
    }

    .literature > .menus > .search-box > input {
        flex: 1;
        height: 40px;
        line-height: 40px;
        padding-left: 12px;
        border: 1px solid #e8e8e8;
        color: #232323;
        box-sizing: border-box;
        font-weight: 400;
        font-size: 14px;
        border-right: 0;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .literature > .menus > .search-box > button {
        height: 40px;
        width: 80px;
        border: 1px solid #e8e8e8;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        color: #232323;
        box-sizing: border-box;
        font-size: 16px;
        font-weight: 400;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .literature > .menus > .search-box > button:active {
        opacity: 0.7;
    }

    .literature > .menus > .search-box > button > .icon {
        margin-right: 8px;
    }

    .literature > .menus > .tops {
        display: flex;
        flex-direction: column;
        background-color: #fff;
        align-items: center;
        position: relative;
        border: 1px solid #e8e8e8;
        box-shadow: 1px 1px 1px #e9e7e7;
    }

    .literature > .menus > .tops .top-head {
        height: 50px;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #e8e8e8;
    }
    
    .literature > .menus > .tops .top-datas {
        display: flex;
        flex-direction: column;
        min-height: 400px;
        width: 100%;
    }
    
    .literature > .menus > .tops .top-datas-item {
        height: 40px;
        line-height: 40px;
        padding-left: 12px;
        border-bottom: 1px dashed #ebebeb;
        margin: 0 8px;
        text-overflow: ellipsis;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
    }

    .literature > .container {
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-right: 20px;
        background-color: #fff;
        padding: 0 24px;
        position: relative;
    }

    .literature > .container .title {
        line-height: 30px;
        text-align: center;
        font-size: 28px;
        font-weight: bold;
        color: #1f1f1f;
        margin-top: 40px;
    }
    
    .literature > .container .row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        height: 42px;
    }

    .literature > .container .creator {
        font-size: 14px;
        font-weight: 400;
        color: #232323;
        line-height: 16px;
        margin-right: 24px;
    }

    .literature > .container .create-time {
        font-size: 14px;
        font-weight: 400;
        color: #666;
        line-height: 16px;
        position: relative;
    }

    .literature > .container .create-time > .icon {
        margin-right: 4px;
    }

    .literature > .container .content-wrapper p {
        font-size: 16px;
        font-weight: 400;
        color: #232323;
        line-height: 24px;
    }

    .literature > .container .content-wrapper img {
        width: 100%;
        object-fit: contain;
    }

    @media only screen and (max-width: 1050px) {
        .literature {
            width: 100%;
            margin-top: 42px;
        }

        .literature > .menus {
            position: absolute;
            width: 80%;
            background-color: #fff;
            box-shadow: 2px 2px 5px #ccc;
            border-radius: 8px;
            padding: 8px;
            display: none;
        }

        .literature > .menus.show {
            display: flex;
        }

        .literature > .router {
            margin: 0 12px;
        }

        .literature > .btn-menu {
            display: flex;
        }
    }
</style>
